<template>
  <b-modal
    v-model="show"
    class="image-cropper"
    title="Upload Photo"
    centered
    hide-footer
    @hide="closeModal"
    @cancel="closeModal"
    @close="closeModal"
  >
    <b-img
      slot="modal-header-close"
      :src="require('@/assets/icons/x.svg')"
      width="40"
      height="24"
    ></b-img>

    <div no-body class="rounded-0 mx-4">
      <div v-if="imgSrc">
        <vue-cropper
          ref="cropper"
          :guides="true"
          drag-mode="crop"
          :src="imgSrc"
          :aspect-ratio="aspectRatio"
          :initial-aspect-ratio="initialAspectRatio"
          :container-style="imageContainer"
          :min-crop-box-width="200"
          :min-crop-box-height="200"
        />
      </div>

      <div class="image-cropper__select" @click="launchFilePicker" v-else>
        <h3 class="image-cropper__label text-center">Click to select image</h3>
        <input
          type="file"
          ref="filePicker"
          @change="onFileChange"
          style="display: none;"
          accept="image/*"
        />
      </div>

      <div class="modal-footer">
        <b-button
          class="btn-outlined bg-white text-dark"
          variant="outline-secondary"
          :disabled="loading"
          @click="closeModal"
          >Cancel</b-button
        >
        <b-button
          class="ml-2"
          variant="primary"
          :loading="loading"
          v-if="this.imgSrc"
          @click="save"
        >
          <b-spinner small v-if="loading"></b-spinner>
          <div v-else>{{ buttonLabel }}</div>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  components: {
    VueCropper
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: 'Save'
    },

    aspectRatio: {
      type: Number,
      default: NaN
    },

    initialAspectRatio: {
      type: Number,
      default: NaN
    },

    blobOnly: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      show: this.value,
      loading: false,
      imgSrc: null,
      imageContainer: { maxHeight: '450px' }
    }
  },

  methods: {
    launchFilePicker() {
      this.$refs.filePicker.click()
    },

    onFileChange(e) {
      const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0]
      if (file && this.isImage(file)) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = e => {
          this.imgSrc = e.target.result
        }
      }
    },

    save() {
      this.$refs.cropper.getCroppedCanvas().toBlob(blob => {
        this.loading = true
        this.$emit(
          'change',
          this.blobOnly
            ? blob
            : {
                blob: blob,
                image: this.imgSrc
              }
        )
      })
    },

    closeModal() {
      this.loading = false
      this.imgSrc = null
      this.$emit('close')
    },

    isImage(file) {
      return file && file['type'].split('/')[0] === 'image'
    }
  },

  created() {
    this.$root.$on('fileChange', e => {
      this.onFileChange(e)
    })

    this.$root.$on('uploadComplete', () => {
      this.closeModal()
    })
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.imgSrc = null
    }
  }
}
</script>

<style scoped lang="scss">
.image-cropper {
  &__select {
    cursor: pointer;
    background: #fafafb;
    border: dashed 1px #b5b5b5;
    border-radius: 6px;
    padding: 80px;
  }

  &__label {
    color: gray;
  }

  .btn.btn-outlined {
    padding: 4px 32px;
  }
  .btn {
    height: 36px;
  }
}

.modal-footer {
  margin-top: 40px;
}
</style>
